module.exports = __webpack_public_path__ + "static/media/sprite.4baac2eb.svg";